import { render } from "./AdminOrderRow.vue?vue&type=template&id=2fdd6c78&scoped=true"
import script from "./AdminOrderRow.vue?vue&type=script&lang=js"
export * from "./AdminOrderRow.vue?vue&type=script&lang=js"

import "./AdminOrderRow.vue?vue&type=style&index=0&id=2fdd6c78&scoped=true&lang=css"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdd6c78"]])

export default __exports__